/**
 * Created by rodrigo on 9/12/17.
 */

import {assignIn, get, isFunction, isObjectLike} from 'lodash'

import i18next from 'i18next';

export const formatPrice = (price = 0, currencySymbol = '$') => price && `${Number.parseFloat(price).toFixed(2)} ${currencySymbol}`

export const validateEmail = (email) => {
  return email && email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? true : false
}

// Validators

const validatorsByKey = {
  test: (test) => (value, values) => !test(value, values),
  validate: (validator) => validator,
}

export const validateFields = (validators) => {
  return (values) => {
    for (let i = 0; i < validators.length; i++) {
      const validator = validators[i]
      if (isObjectLike(validator)) {
        const {field, error, ...tests} = validator
        const value = get(values, field)
        const testError = Object.keys(tests).map(key => {
          const validator = validatorsByKey[key]
          const testValue = tests[key]
          if (!validator) {
            console.warn('Unknown validator: ' + key)
            return false
          }
          return validator(testValue)(value, values, field, error)
        }).find(e => e)
        if (testError) {
          return {[field]: error || testError}
        }
      }
      else if (isFunction(validator)) {
        const testError = validator(values)
        if (testError) {
          return testError
        }
      }
      else {
        console.warn('Unknown validator: ' + validator)
      }
    }
  }
}

export const translate = (key, payload) => {
  return i18next.t(key, payload)
}

export const i18n = assignIn(translate, i18next, {

  initialize: () => {
    i18next.init({ nsSeparator: '|', fallbackLng: 'es' });
    i18next.addResourceBundle('es', 'translation', require('./locales/es.json'));
    i18next.addResourceBundle('en', 'translation', require('./locales/en.json'));
  },

  changeLanguage: (locale) => {
    i18next.changeLanguage(locale)
  },

  t: (key, payload) => {
    return i18next.t(key, payload)
  }
})




// WEBPACK FOOTER //
// ./client/utils.js